import Icon from '@forwardflow/ui/Icons'

import { Link, useParams } from 'react-router-dom'
import { useMemo } from 'react'
import AppointmentPreference from '../AppointmentPreference'
import { useGetUserDetailsByEmail } from '@forwardflow/hooks/customHooks/organization/useGetUserDetailsByEmail'
import { Avatar, Skeleton } from 'antd'
import { UserAccessPermission } from '../UserAccessPermission'

const ViewUserAccount = () => {
   const { id: email } = useParams()

   const { data: userDetails, isLoading } = useGetUserDetailsByEmail(
      email || ''
   )
   const initials =
      userDetails?.firstName.charAt(0) +
      (userDetails?.lastName?.charAt(0) || '')

   const avatarColor = useMemo(() => {
      const name = `${userDetails?.firstName || ''}${
         userDetails?.lastName || ''
      }`
      const hash = name
         .split('')
         .reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0)

      const colors = [
         '#f56a00',
         '#7265e6',
         '#ffbf00',
         '#00a2ae',
         '#712704',
         '#04B404',
         '#0174DF',
         '#8A0886',
         '#DF0101',
         '#04B4AE',
      ]

      const colorIndex = Math.abs(hash) % colors.length
      return colors[colorIndex]
   }, [userDetails])

   if (isLoading) {
      return (
         <div className="flex h-full">
            <Skeleton active></Skeleton>
         </div>
      )
   }

   return (
      <div className="flex flex-col flex-1">
         <div className="flex items-center py-6 pl-10 pr-4 bg-white/5">
            <Link to={`/settings/user-management`} className="flexc">
               <Icon
                  name="arrow-right"
                  className="scale-75 rotate-180 cursor-pointer fill-white mr-7"
               />
               <span className="opacity-70">User Management /</span>
            </Link>

            <span className="ml-1 font-medium">
               {userDetails?.firstName || ''} {userDetails?.lastName || ''}
            </span>
         </div>

         <div className="flex justify-between px-10 py-5 mt-1 bg-primary/10">
            <div className="flex items-center gap-2">
               <Avatar
                  className="w-10 h-10 mr-4 font-semibold"
                  style={{ backgroundColor: avatarColor }}
               >
                  {initials}
               </Avatar>
               <p className="font-medium">
                  {userDetails?.firstName || ''} {userDetails?.lastName || ''}
               </p>
               <p className="text-[12px] text-white/70 py-1 px-2 ml-4 bg-black/20 hidden">
                  ADMIN
               </p>
            </div>

            <div className="hidden gap-4 flexc">
               <button className="h-10 gap-3 px-5 font-medium rounded bg-black/10 hover:bg-black/20 flexc">
                  Pause Access
               </button>
               <div className="w-10 h-10 border rounded cursor-pointer flexc border-danger bg-danger/20 hover:bg-danger/50 fill-white shrink-0">
                  <Icon name="Delete" />
               </div>
            </div>
         </div>
         <div className="items-center justify-between hidden px-10 py-5 mt-1 bg-primary/5">
            <span>User Created: 16 Jun 2024</span>
            <span>Account Age: 6 months</span>
         </div>
         <div className="items-center justify-between px-10 py-5 mt-1 text-[12px] text-white/70 ">
            APPOINTMENT PREFERENCE
         </div>
         <AppointmentPreference email={userDetails?.email || ''} />
         <UserAccessPermission
            email={userDetails?.email || ''}
            userId={userDetails?.id?.toString() || ''}
         />
      </div>
   )
}
export default ViewUserAccount
